import { render } from "./LbrxHomeFeatures.vue?vue&type=template&id=cf209d64&scoped=true"
import script from "./LbrxHomeFeatures.vue?vue&type=script&lang=js"
export * from "./LbrxHomeFeatures.vue?vue&type=script&lang=js"

import "./LbrxHomeFeatures.vue?vue&type=style&index=0&id=cf209d64&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf209d64"]])

export default __exports__